import { OrderReducer } from './order.reducer';

export const reducers = OrderReducer;
